import { InventoryPolicy } from '@playq/octopus2-economy';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';

import { appsInventoryService } from './constants';

export const appsInventoryPolicyKeys = ['apps', 'inventory', 'policy'];

const emptyArray: [] = [];

export const useAppsInventoryPolicy = (
  options?: IUseQueryOptionsExtended<InventoryPolicy | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(appsInventoryPolicyKeys, () => appsInventoryService.policy(), {
    ...options,
    staleTime: 5 * 1000 * 60,
  });
  const data = res.data instanceof InventoryPolicy ? res.data : new InventoryPolicy();
  const classes = res.data?.classes ?? emptyArray;

  return { ...res, data, classes, keys: appsInventoryPolicyKeys };
};
